let timeOut = null
export const DebounceDirective = {
  inserted: (el, binding) => {
    let e = document.createEvent('HTMLEvents')
    e.initEvent('debounced', true, true)
    waitKeyUp(el, binding, e)
  }
}

let waitKeyUp = (el, binding, evt) => {
  el.onkeyup = (ev) => {
    let debounceValue = Number.parseInt(binding.value)
    if (!isNaN(debounceValue) && debounceValue > 0) {
      clearTimeout(timeOut)
      timeOut = setTimeout(() => {
        el.dispatchEvent(evt)
      }, binding.value)
    } else {
      el.dispatchEvent(evt)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/primitives/helpers/debounce/Debounce.js